"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _recompose = require("recompose");

var _lodash = require("lodash");

var _search = _interopRequireDefault(require("react-icons/lib/fa/search"));

var _emotion = require("emotion");

require("./AggregationCard.css");

var _utils = require("../SQONView/utils");

var _AggsWrapper = _interopRequireDefault(require("./AggsWrapper"));

var _TextHighlight = _interopRequireDefault(require("../TextHighlight"));

require("./TermAgg.css");

var _ToggleButton = _interopRequireDefault(require("../ToggleButton"));

var _translateSQONValue = _interopRequireDefault(require("../utils/translateSQONValue"));

var _Input = _interopRequireDefault(require("../Input"));

var _strToReg = _interopRequireDefault(require("../utils/strToReg"));

var _formatNumber = _interopRequireDefault(require("../utils/formatNumber"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _generateNextSQON = function generateNextSQON(_ref) {
  var dotField = _ref.dotField,
      bucket = _ref.bucket,
      isExclude = _ref.isExclude,
      sqon = _ref.sqon;
  return (0, _utils.toggleSQON)({
    op: 'and',
    content: [{
      op: isExclude ? 'not-in' : 'in',
      content: {
        field: dotField,
        value: [].concat(bucket.name || [])
      }
    }]
  }, sqon);
};

var IncludeExcludeButton = function IncludeExcludeButton(_ref2) {
  var dotField = _ref2.dotField,
      buckets = _ref2.buckets,
      isActive = _ref2.isActive,
      isExclude = _ref2.isExclude,
      updateIsExclude = _ref2.updateIsExclude,
      handleIncludeExcludeChange = _ref2.handleIncludeExcludeChange;
  return /*#__PURE__*/_react["default"].createElement(_ToggleButton["default"], {
    value: isExclude ? 'exclude' : 'include',
    options: [{
      title: 'Include',
      value: 'include'
    }, {
      title: 'Exclude',
      value: 'exclude'
    }],
    onChange: function onChange(_ref3) {
      var value = _ref3.value,
          _ref3$isExclude = _ref3.isExclude,
          isExclude = _ref3$isExclude === void 0 ? value === 'exclude' : _ref3$isExclude;
      var activeBuckets = buckets.filter(function (b) {
        return isActive({
          field: dotField,
          value: b.name
        });
      });
      handleIncludeExcludeChange({
        isExclude: isExclude,
        buckets: activeBuckets,
        generateNextSQON: function generateNextSQON(sqon) {
          return activeBuckets.reduce(function (q, bucket) {
            return _generateNextSQON({
              dotField: dotField,
              isExclude: isExclude,
              bucket: bucket,
              sqon: q
            });
          }, (0, _utils.removeSQON)(dotField, sqon));
        }
      });
      updateIsExclude(isExclude);
    }
  });
};

var MoreOrLessButton = function MoreOrLessButton(_ref4) {
  var howManyMore = _ref4.howManyMore,
      isMore = _ref4.isMore,
      onClick = _ref4.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "showMore-wrapper ".concat(isMore ? 'more' : 'less'),
    onClick: onClick
  }, isMore ? "".concat(howManyMore, " More") : 'Less');
};

var decorateBuckets = function decorateBuckets(_ref5) {
  var buckets = _ref5.buckets,
      searchText = _ref5.searchText;
  var namedFilteredBuckets = buckets.map(function (b) {
    return _objectSpread(_objectSpread({}, b), {}, {
      name: b.key_as_string || b.key
    });
  }).filter(function (b) {
    return !searchText || (0, _translateSQONValue["default"])(b.name).match((0, _strToReg["default"])(searchText));
  });

  var _partition = (0, _lodash.partition)(namedFilteredBuckets, {
    name: '__missing__'
  }),
      _partition2 = _slicedToArray(_partition, 2),
      missing = _partition2[0],
      notMissing = _partition2[1];

  return [].concat(_toConsumableArray((0, _lodash.orderBy)(notMissing, 'doc_count', 'desc')), _toConsumableArray(missing));
};

var enhance = (0, _recompose.compose)((0, _recompose.withState)('stateShowingMore', 'setShowingMore', false), (0, _recompose.withState)('stateIsExclude', 'setIsExclude', false), (0, _recompose.withState)('stateShowingSearch', 'setShowingSearch', false), (0, _recompose.withState)('searchText', 'setSearchText', ''));

var TermAgg = function TermAgg(_ref6) {
  var _ref6$field = _ref6.field,
      field = _ref6$field === void 0 ? '' : _ref6$field,
      _ref6$displayName = _ref6.displayName,
      displayName = _ref6$displayName === void 0 ? 'Unnamed Field' : _ref6$displayName,
      _ref6$headerTitle = _ref6.headerTitle,
      headerTitle = _ref6$headerTitle === void 0 ? null : _ref6$headerTitle,
      _ref6$buckets = _ref6.buckets,
      buckets = _ref6$buckets === void 0 ? [] : _ref6$buckets,
      _ref6$handleValueClic = _ref6.handleValueClick,
      handleValueClick = _ref6$handleValueClic === void 0 ? function () {} : _ref6$handleValueClic,
      _ref6$isActive = _ref6.isActive,
      isActive = _ref6$isActive === void 0 ? function () {} : _ref6$isActive,
      _ref6$Content = _ref6.Content,
      Content = _ref6$Content === void 0 ? 'div' : _ref6$Content,
      _ref6$SearchIcon = _ref6.SearchIcon,
      SearchIcon = _ref6$SearchIcon === void 0 ? _search["default"] : _ref6$SearchIcon,
      _ref6$maxTerms = _ref6.maxTerms,
      maxTerms = _ref6$maxTerms === void 0 ? 5 : _ref6$maxTerms,
      _ref6$collapsible = _ref6.collapsible,
      collapsible = _ref6$collapsible === void 0 ? true : _ref6$collapsible,
      _ref6$isExclude = _ref6.isExclude,
      externalIsExclude = _ref6$isExclude === void 0 ? function () {} : _ref6$isExclude,
      _ref6$showExcludeOpti = _ref6.showExcludeOption,
      showExcludeOption = _ref6$showExcludeOpti === void 0 ? false : _ref6$showExcludeOpti,
      _ref6$handleIncludeEx = _ref6.handleIncludeExcludeChange,
      handleIncludeExcludeChange = _ref6$handleIncludeEx === void 0 ? function () {} : _ref6$handleIncludeEx,
      _ref6$constructEntryI = _ref6.constructEntryId,
      constructEntryId = _ref6$constructEntryI === void 0 ? function (_ref7) {
    var value = _ref7.value;
    return value;
  } : _ref6$constructEntryI,
      valueCharacterLimit = _ref6.valueCharacterLimit,
      _ref6$observableValue = _ref6.observableValueInFocus,
      observableValueInFocus = _ref6$observableValue === void 0 ? null : _ref6$observableValue,
      WrapperComponent = _ref6.WrapperComponent,
      highlightText = _ref6.highlightText,
      _ref6$constructBucket = _ref6.constructBucketItemClassName,
      constructBucketItemClassName = _ref6$constructBucket === void 0 ? function () {
    return '';
  } : _ref6$constructBucket,
      _ref6$searchPlacehold = _ref6.searchPlaceholder,
      searchPlaceholder = _ref6$searchPlacehold === void 0 ? 'Search' : _ref6$searchPlacehold,
      containerRef = _ref6.containerRef,
      _ref6$aggWrapperRef = _ref6.aggWrapperRef,
      aggWrapperRef = _ref6$aggWrapperRef === void 0 ? /*#__PURE__*/_react["default"].createRef() : _ref6$aggWrapperRef,
      _ref6$aggHeaderRef = _ref6.aggHeaderRef,
      aggHeaderRef = _ref6$aggHeaderRef === void 0 ? /*#__PURE__*/_react["default"].createRef() : _ref6$aggHeaderRef,
      _ref6$scrollToAgg = _ref6.scrollToAgg,
      scrollToAgg = _ref6$scrollToAgg === void 0 ? function () {
    if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) containerRef.current.scrollTop = aggWrapperRef.current.offsetTop - aggHeaderRef.current.getBoundingClientRect().height;
  } : _ref6$scrollToAgg,
      stateShowingMore = _ref6.stateShowingMore,
      setShowingMore = _ref6.setShowingMore,
      stateIsExclude = _ref6.stateIsExclude,
      setIsExclude = _ref6.setIsExclude,
      stateShowingSearch = _ref6.stateShowingSearch,
      setShowingSearch = _ref6.setShowingSearch,
      searchText = _ref6.searchText,
      setSearchText = _ref6.setSearchText,
      _ref6$InputComponent = _ref6.InputComponent,
      InputComponent = _ref6$InputComponent === void 0 ? _Input["default"] : _ref6$InputComponent,
      type = _ref6.type;
  var decoratedBuckets = decorateBuckets({
    buckets: buckets,
    searchText: searchText
  });
  var dotField = field.replace(/__/g, '.');
  var isExclude = externalIsExclude({
    field: dotField
  }) || stateIsExclude;
  var hasSearchHit = highlightText && decoratedBuckets.some(function (x) {
    return x.name.match((0, _strToReg["default"])(searchText));
  });
  var showingMore = stateShowingMore || hasSearchHit;
  var isMoreEnabled = decoratedBuckets.length > maxTerms;

  var dataFields = _objectSpread(_objectSpread({}, field && {
    'data-field': field
  }), type && {
    'data-type': type
  });

  return /*#__PURE__*/_react["default"].createElement(_AggsWrapper["default"], {
    componentRef: aggWrapperRef,
    headerRef: aggHeaderRef,
    stickyHeader: true,
    dataFields: dataFields,
    displayName: displayName,
    WrapperComponent: WrapperComponent,
    collapsible: collapsible,
    ActionIcon: /*#__PURE__*/_react["default"].createElement(_search["default"], {
      onClick: function onClick() {
        return setShowingSearch(!stateShowingSearch);
      }
    }),
    filters: [].concat(_toConsumableArray(stateShowingSearch ? [/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(InputComponent, {
      className:
      /*#__PURE__*/

      /*#__PURE__*/
      (0, _emotion.css)("flex-grow:1;"),
      type: "text",
      value: searchText,
      placeholder: searchPlaceholder,
      icon: /*#__PURE__*/_react["default"].createElement(_search["default"], null),
      onChange: function onChange(_ref8) {
        var value = _ref8.target.value;
        return setSearchText(value || '');
      },
      setSearchText: setSearchText,
      "aria-label": "Search data"
    }), showingMore && isMoreEnabled && /*#__PURE__*/_react["default"].createElement(MoreOrLessButton, {
      isMore: false,
      onClick: function onClick() {
        setShowingMore(false);
        setShowingSearch(false);
        scrollToAgg();
      }
    }))] : []), _toConsumableArray(showExcludeOption && !(0, _lodash.isEmpty)(decoratedBuckets) ? [/*#__PURE__*/_react["default"].createElement(IncludeExcludeButton, {
      dotField: dotField,
      isActive: isActive,
      isExclude: isExclude,
      handleIncludeExcludeChange: handleIncludeExcludeChange,
      buckets: decoratedBuckets,
      updateIsExclude: setIsExclude
    })] : []))
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, headerTitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "header"
  }, headerTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bucket"
  }, decoratedBuckets.slice(0, showingMore ? Infinity : maxTerms).map(function (bucket, i, array) {
    return /*#__PURE__*/_react["default"].createElement(Content, {
      id: constructEntryId({
        value: "".concat(field, "--").concat(bucket.name.replace(/\s/g, '-'))
      }),
      key: bucket.name,
      className: "bucket-item ".concat(constructBucketItemClassName({
        bucket: bucket,
        i: i,
        showingBuckets: array,
        showingMore: showingMore
      }) || ''),
      content: {
        field: dotField,
        value: bucket.name
      },
      onClick: function onClick() {
        return handleValueClick({
          field: dotField,
          value: bucket,
          isExclude: isExclude,
          generateNextSQON: function generateNextSQON(sqon) {
            return _generateNextSQON({
              isExclude: isExclude,
              dotField: dotField,
              bucket: bucket,
              sqon: sqon
            });
          }
        });
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "bucket-link",
      merge: "toggle"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      readOnly: true,
      type: "checkbox",
      checked: isActive({
        field: dotField,
        value: bucket.name
      }),
      "aria-label": "Select ".concat(bucket.name),
      id: "input-".concat(field, "-").concat(bucket.name.replace(/\s/g, '-')),
      name: "input-".concat(field, "-").concat(bucket.name.replace(/\s/g, '-'))
    }), /*#__PURE__*/_react["default"].createElement(_TextHighlight["default"], {
      content: (0, _lodash.truncate)((0, _translateSQONValue["default"])(bucket.name), {
        length: valueCharacterLimit || Infinity
      }) + ' ',
      highlightText: highlightText
    })), bucket.doc_count && /*#__PURE__*/_react["default"].createElement("span", {
      className: "bucket-count"
    }, (0, _formatNumber["default"])(bucket.doc_count)));
  })), isMoreEnabled && /*#__PURE__*/_react["default"].createElement(MoreOrLessButton, {
    isMore: !showingMore,
    onClick: function onClick() {
      setShowingMore(!showingMore);
      setShowingSearch(!showingMore);
      if (showingMore) scrollToAgg();
    },
    howManyMore: decoratedBuckets.length - maxTerms
  })));
};

var _default = enhance(TermAgg);

exports["default"] = _default;